module.exports = __webpack_public_path__ + "img/delete-light.9db41da3.svg";